namespace Serenity {
    export interface OperationStatusResponse extends Serenity.ServiceResponse {
        Progress?: number;
        StatusText?: string;
    }
}
